import { Component, Input } from "@angular/core";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

@Component({
    selector: 'icon-text-button',
    templateUrl: 'iconTextButton.component.html',
    styleUrls: ['iconTextButton.component.scss']
})

export class IconTextButtonComponent {
    @Input()
    icon: IconProp = 'question';

    @Input()
    text: string = '';

    @Input()
    color: 'blue' | 'red' = 'blue';

    @Input()
    shape: 'round' | 'square' = 'round';

    @Input()
    disabled: boolean = false;

    colorClass(): string {
        switch (this.color) {
            case 'blue':
                return 'icon-text-button' + (this.shape === 'square' ? 'blue' : '');
            case 'red':
                return 'icon-text-button_red' + (this.shape === 'square' ? '_red' : '');
        }
    }

    shapeClass(): string {
        switch (this.shape) {
            case 'round':
                return 'icon-text-button' + (this.color === 'blue' ? '' : '_red');
            case 'square':
                return 'icon-text-button-square' + (this.color === 'blue' ? '' : '_red');
        }
    }

    disableButton() {
        if (this.disabled) {
            return this.shapeClass() + '_disabled';
        }
        else {
            return this.shapeClass();
        }
    }
}